<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Aroma"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-aroma">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
